import React, { useState, useCallback, useContext, useEffect } from "react";
import { toast } from "react-toastify";
import { add, format, parseISO } from "date-fns";

import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import PopupState, { bindTrigger, bindMenu } from "material-ui-popup-state";
// import { SocketContext } from "../../context/Socket/SocketContext";
import { makeStyles } from "@material-ui/core/styles";
import { green } from "@material-ui/core/colors";
import {
  Button,
  TableBody,
  TableRow,
  TableCell,
  IconButton,
  Table,
  TableHead,
  Paper,
  Tooltip,
  Typography,
  CircularProgress,
  Box,
  Card,
  CardContent,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Select,
  MenuItem as MuiMenuItem,
  FormControl,
  InputLabel,
  Switch,
  Checkbox,
  FormControlLabel,
  Tooltip as MuiTooltip,
} from "@material-ui/core";
import {
  Edit,
  CheckCircle,
  SignalCellularConnectedNoInternet2Bar,
  SignalCellularConnectedNoInternet0Bar,
  SignalCellular4Bar,
  CropFree,
  DeleteOutline,
  Facebook,
  Instagram,
  WhatsApp,
  Sync,
  Chat,
  Code,
  HelpOutline,
} from "@material-ui/icons";
import WebhookIcon from '@mui/icons-material/Webhook';
import FacebookLogin from "react-facebook-login/dist/facebook-login-render-props";

import MainContainer from "../../components/MainContainer";
import MainHeader from "../../components/MainHeader";
import MainHeaderButtonsWrapper from "../../components/MainHeaderButtonsWrapper";
import Title from "../../components/Title";
import TableRowSkeleton from "../../components/TableRowSkeleton";

import api from "../../services/api";
import WhatsAppModal from "../../components/WhatsAppModal";
import ConfirmationModal from "../../components/ConfirmationModal";
import QrcodeModal from "../../components/QrcodeModal";
import PairPhoneModal from "../../components/PairPhoneModal";
import { i18n } from "../../translate/i18n";
import { WhatsAppsContext } from "../../context/WhatsApp/WhatsAppsContext";
import toastError from "../../errors/toastError";
import formatSerializedId from '../../utils/formatSerializedId';
import whatsmeowIcon from "../../assets/whatsmeow.png";
import { AuthContext } from "../../context/Auth/AuthContext";
import usePlans from "../../hooks/usePlans";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { Can } from "../../components/Can";

const useStyles = makeStyles((theme) => ({
  mainPaper: {
    flex: 1,
    // padding: theme.spacing(1),
    padding: theme.padding,
    overflowY: "scroll",
    ...theme.scrollbarStyles,
  },
  customTableCell: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  tooltip: {
    backgroundColor: "#f5f5f9",
    color: "rgba(0, 0, 0, 0.87)",
    fontSize: theme.typography.pxToRem(14),
    border: "1px solid #dadde9",
    maxWidth: 450,
  },
  tooltipPopper: {
    textAlign: "center",
  },
  buttonProgress: {
    color: green[500],
  },
}));

function CircularProgressWithLabel(props) {
  return (
    <Box position="relative" display="inline-flex">
      <CircularProgress variant="determinate" {...props} />
      <Box
        top={0}
        left={0}
        bottom={0}
        right={0}
        position="absolute"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <Typography
          variant="caption"
          component="div"
          color="textSecondary"
        >{`${Math.round(props.value)}%`}</Typography>
      </Box>
    </Box>
  );
}

const CustomToolTip = ({ title, content, children }) => {
  const classes = useStyles();

  return (
    <Tooltip
      arrow
      classes={{
        tooltip: classes.tooltip,
        popper: classes.tooltipPopper,
      }}
      title={
        <React.Fragment>
          <Typography gutterBottom color="inherit">
            {title}
          </Typography>
          {content && <Typography>{content}</Typography>}
        </React.Fragment>
      }
    >
      {children}
    </Tooltip>
  );
};

const IconChannel = (channel) => {
  // Normalizar channel para lowercase para comparação case-insensitive
  const normalizedChannel = channel ? channel.toLowerCase().trim() : "";
  
  // Debug: log para verificar qual channel está chegando
  if (normalizedChannel === "wuzapi" || normalizedChannel === "whatsmeow") {
    console.log("[IconChannel] Channel detectado:", normalizedChannel, "Original:", channel);
  }
  
  switch (normalizedChannel) {
    case "facebook":
      return <Facebook style={{ color: "#3b5998" }} />;
    case "instagram":
      return <Instagram style={{ color: "#e1306c" }} />;
    case "whatsapp":
      return <WhatsApp style={{ color: "#25d366" }} />;
    case "whatsapp_oficial":
      return <WhatsApp style={{ color: "#25d366" }} />;
    case "wuzapi":
      return (
        <img
          src={whatsmeowIcon}
          alt="WuzAPI"
          style={{ width: 24, height: 24, objectFit: "contain" }}
          onError={(e) => {
            console.error("[IconChannel] Erro ao carregar whatsmeow.png:", e);
            e.target.style.display = 'none';
          }}
          onLoad={() => {
            console.log("[IconChannel] ✅ whatsmeow.png carregado com sucesso!");
          }}
        />
      );
    case "whatsmeow":
      return (
        <img
          src={whatsmeowIcon}
          alt="WhatsMeow"
          style={{ width: 24, height: 24, objectFit: "contain" }}
          onError={(e) => {
            console.error("[IconChannel] Erro ao carregar whatsmeow.png:", e);
            e.target.style.display = 'none';
          }}
          onLoad={() => {
            console.log("[IconChannel] ✅ whatsmeow.png carregado com sucesso!");
          }}
        />
      );
    case "webchat":
      return <Chat style={{ color: "#0066ff" }} />;
    default:
      // Se não encontrar, retornar WhatsApp como fallback
      console.warn("[IconChannel] Channel desconhecido:", channel, "normalized:", normalizedChannel);
      return <WhatsApp style={{ color: "#25d366" }} />;
  }
};

const Connections = () => {
  const classes = useStyles();

  const { whatsApps, loading } = useContext(WhatsAppsContext);
  const [whatsAppModalOpen, setWhatsAppModalOpen] = useState(false);
  
  // Log via useEffect para garantir execução
  useEffect(() => {
    console.log("[DEBUG] Connections useEffect - whatsApps:", whatsApps, "loading:", loading);
    if (whatsApps && whatsApps.length > 0) {
      whatsApps.forEach((wa) => {
        console.log("[DEBUG] Conexão encontrada - ID:", wa.id, "Channel:", wa.channel, "Status:", wa.status, "Nome:", wa.name);
      });
    }
  }, [whatsApps, loading]);
  const [statusImport, setStatusImport] = useState([]);
  const [qrModalOpen, setQrModalOpen] = useState(false);
  const [pairPhoneModalOpen, setPairPhoneModalOpen] = useState(false);
  const [selectedWhatsApp, setSelectedWhatsApp] = useState(null);
  const [channel, setChannel] = useState("whatsapp");
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);
  const history = useHistory();
  const confirmationModalInitialState = {
    action: "",
    title: "",
    message: "",
    whatsAppId: "",
    open: false,
  };
  const [confirmModalInfo, setConfirmModalInfo] = useState(confirmationModalInitialState);
  const [planConfig, setPlanConfig] = useState(false);
  const [transferModalOpen, setTransferModalOpen] = useState(false);
  const [sourceConnection, setSourceConnection] = useState("");
  const [targetConnection, setTargetConnection] = useState("");
  const [includeTicketsWithoutConnection, setIncludeTicketsWithoutConnection] = useState(false);
  const [preDeleteModalOpen, setPreDeleteModalOpen] = useState(false);
  const [whatsAppToDelete, setWhatsAppToDelete] = useState(null);
  const [transferProgressModalOpen, setTransferProgressModalOpen] = useState(false);
  const [transferProgress, setTransferProgress] = useState({ 
    current: 0, 
    total: 0, 
    percentage: 0, 
    failed: 0,
    jobId: null 
  });

  //   const socketManager = useContext(SocketContext);
  const { user, socket } = useContext(AuthContext);

  const hasAvailableQrCode = (whatsApp) => {
    const isQrChannel =
      whatsApp?.channel === "whatsapp" ||
      whatsApp?.channel === "whatsmeow" ||
      whatsApp?.channel === "wuzapi";

    if (!isQrChannel) return false;

    return Boolean(whatsApp?.qrcode) && (
      whatsApp?.status === "qrcode" || whatsApp?.status === "OPENING"
    );
  };

  const companyId = user.companyId;

  const { getPlanCompany } = usePlans();

  useEffect(() => {
    async function fetchData() {
      const planConfigs = await getPlanCompany(undefined, companyId);
      setPlanConfig(planConfigs)
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const responseFacebook = (response) => {
    if (response.status !== "unknown") {
      const { accessToken, id } = response;

      api
        .post("/facebook", {
          facebookUserId: id,
          facebookUserToken: accessToken,
        })
        .then((response) => {
          toast.success(i18n.t("connections.facebook.success"));
        })
        .catch((error) => {
          toastError(error);
        });
    }
  };

  const responseInstagram = (response) => {
    if (response.status !== "unknown") {
      const { accessToken, id } = response;

      api
        .post("/facebook", {
          addInstagram: true,
          facebookUserId: id,
          facebookUserToken: accessToken,
        })
        .then((response) => {
          toast.success(i18n.t("connections.facebook.success"));
        })
        .catch((error) => {
          toastError(error);
        });
    }
  };

  useEffect(() => {
    // const socket = socketManager.GetSocket();

    if (!socket || typeof socket.on !== 'function') {
      return;
    }

    const onImportMessages = (data) => {
      if (data.action === "refresh") {
        setStatusImport([]);
        history.go(0);
      }
      if (data.action === "update") {
        setStatusImport(data.status);
      }
    };

    const onTransferTickets = (data) => {
      console.log("[TRANSFER FRONTEND] Evento recebido:", data);
      
      if (data.action === "progress") {
        console.log(`[TRANSFER FRONTEND] Progresso: ${data.current}/${data.total} (${data.percentage}%)`);
        setTransferProgress({
          current: data.current,
          total: data.total,
          percentage: data.percentage || Math.round((data.current / data.total) * 100),
          failed: data.failed || 0,
          jobId: data.jobId
        });
      }
      if (data.action === "completed") {
        setTransferProgressModalOpen(false);
        const successMsg = data.failed > 0
          ? `Transferência concluída! ${data.transferred} tickets transferidos com sucesso. ${data.failed} tickets falharam.`
          : `Transferência concluída! ${data.transferred} tickets transferidos com sucesso.`;
        toast.success(successMsg);
        setTransferProgress({ current: 0, total: 0, percentage: 0, failed: 0, jobId: null });
        handleCloseTransferModal();
      }
      if (data.action === "error") {
        setTransferProgressModalOpen(false);
        setTransferProgress({ current: 0, total: 0, percentage: 0, failed: 0, jobId: null });
        toast.error("Erro na transferência de tickets.");
      }
      if (data.action === "cancelled") {
        setTransferProgressModalOpen(false);
        setTransferProgress({ current: 0, total: 0, percentage: 0, failed: 0, jobId: null });
        toast.warning(`Transferência cancelada. ${data.transferred} tickets foram transferidos antes do cancelamento.`);
      }
    };

    socket.on(`importMessages-${user.companyId}`, onImportMessages);
    socket.on(`transferTickets-${user.companyId}`, onTransferTickets);

    return () => {
      if (socket && typeof socket.off === 'function') {
        socket.off(`importMessages-${user.companyId}`, onImportMessages);
        socket.off(`transferTickets-${user.companyId}`, onTransferTickets);
      }
    };
  }, [whatsApps, socket, user.companyId, history]);

  const handleStartWhatsAppSession = async (whatsAppId) => {
    console.log("[FRONTEND-DEBUG] ========== handleStartWhatsAppSession CHAMADO ==========");
    console.log("[FRONTEND-DEBUG] WhatsApp ID:", whatsAppId);
    console.log("[FRONTEND-DEBUG] URL:", `/whatsappsession/${whatsAppId}`);
    console.log("[FRONTEND-DEBUG] Base URL:", process.env.REACT_APP_BACKEND_URL);
    try {
      console.log("[FRONTEND-DEBUG] Fazendo POST para:", `${process.env.REACT_APP_BACKEND_URL}/whatsappsession/${whatsAppId}`);
      const response = await api.post(`/whatsappsession/${whatsAppId}`);
      console.log("[FRONTEND-DEBUG] ✅ Resposta recebida:", response);
    } catch (err) {
      console.error("[FRONTEND-DEBUG] ❌ ERRO na requisição:", err);
      console.error("[FRONTEND-DEBUG] Erro completo:", JSON.stringify(err, null, 2));
      toastError(err);
    }
  };

  const handleRequestNewQrCode = async (whatsAppId) => {
    console.log("[FRONTEND-DEBUG] ========== handleRequestNewQrCode CHAMADO ==========");
    console.log("[FRONTEND-DEBUG] WhatsApp ID:", whatsAppId);
    console.log("[FRONTEND-DEBUG] URL:", `/whatsappsession/${whatsAppId}`);
    console.log("[FRONTEND-DEBUG] Base URL:", process.env.REACT_APP_BACKEND_URL);
    try {
      console.log("[FRONTEND-DEBUG] Fazendo PUT para:", `${process.env.REACT_APP_BACKEND_URL}/whatsappsession/${whatsAppId}`);
      const response = await api.put(`/whatsappsession/${whatsAppId}`);
      console.log("[FRONTEND-DEBUG] ✅ Resposta recebida:", response);
    } catch (err) {
      console.error("[FRONTEND-DEBUG] ❌ ERRO na requisição:", err);
      console.error("[FRONTEND-DEBUG] Erro completo:", JSON.stringify(err, null, 2));
      toastError(err);
    }
  };

  const handleOpenWhatsAppModal = (channel) => {
    setChannel(channel)
    setSelectedWhatsApp(null);
    setWhatsAppModalOpen(true);
  };

  const handleCloseWhatsAppModal = useCallback(() => {
    setWhatsAppModalOpen(false);
    setSelectedWhatsApp(null);
    setChannel("whatsapp"); // Resetar para o padrão
  }, [setSelectedWhatsApp, setWhatsAppModalOpen]);

  const handleOpenQrModal = (whatsApp) => {
    setSelectedWhatsApp(whatsApp);
    setQrModalOpen(true);
  };

  const handleCloseQrModal = useCallback(() => {
    setSelectedWhatsApp(null);
    setQrModalOpen(false);
  }, [setQrModalOpen, setSelectedWhatsApp]);

  const handleOpenPairPhoneModal = (whatsApp) => {
    setSelectedWhatsApp(whatsApp);
    setPairPhoneModalOpen(true);
  };

  const handleClosePairPhoneModal = useCallback(() => {
    setSelectedWhatsApp(null);
    setPairPhoneModalOpen(false);
  }, [setSelectedWhatsApp]);

  const handleEditWhatsApp = (whatsApp) => {
    setChannel(whatsApp.channel)
    setSelectedWhatsApp(whatsApp);
    setWhatsAppModalOpen(true);
  };

  const handleSyncTemplates = async (whatsAppId) => {
    await api.get(`/whatsapp/sync-templates/${whatsAppId}`);
  };

  const handleToggleReceiveComments = async (whatsApp) => {
    try {
      const newValue = !whatsApp.receiveComments;
      await api.put(`/whatsapp/${whatsApp.id}`, {
        receiveComments: newValue
      });
      toast.success(
        newValue 
          ? i18n.t("connections.receiveComments.enabled") 
          : i18n.t("connections.receiveComments.disabled")
      );
    } catch (err) {
      toastError(err);
    }
  };

  const handleCopyWebhook = (whatsApp) => {
    if (!whatsApp) return;

    // 1) Tenta usar o webhook salvo no banco (criado automaticamente pela API oficial)
    let url = whatsApp.waba_webhook;

    // 2) Se não tiver salvo, monta a URL padrão do backend
    if (!url) {
      const base =
        (process.env.REACT_APP_BACKEND_URL &&
          process.env.REACT_APP_BACKEND_URL.replace(/\/$/, "")) ||
        window.location.origin.replace(/\/$/, "");

      const companyId = whatsApp.companyId || user.companyId;
      url = `${base}/v1/webhook/${companyId}/${whatsApp.id}`;
    }

    if (!url) {
      toast.error("Não foi possível gerar a URL do webhook.");
      return;
    }

    navigator.clipboard
      .writeText(url)
      .then(() => {
        toast.success("Webhook copiado para a área de transferência!");
      })
      .catch(() => {
        toast.error("Erro ao copiar o webhook. Tente novamente.");
      });
  };

  const openInNewTab = url => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  const handleOpenConfirmationModal = (action, whatsAppId) => {
    if (action === "disconnect") {
      setConfirmModalInfo({
        action: action,
        title: i18n.t("connections.confirmationModal.disconnectTitle"),
        message: i18n.t("connections.confirmationModal.disconnectMessage"),
        whatsAppId: whatsAppId,
      });
    }

    if (action === "delete") {
      setConfirmModalInfo({
        action: action,
        title: i18n.t("connections.confirmationModal.deleteTitle"),
        message: i18n.t("connections.confirmationModal.deleteMessage"),
        whatsAppId: whatsAppId,
      });
    }
    if (action === "closedImported") {
      setConfirmModalInfo({
        action: action,
        title: i18n.t("connections.confirmationModal.closedImportedTitle"),
        message: i18n.t("connections.confirmationModal.closedImportedMessage"),
        whatsAppId: whatsAppId,
      });
    }

    setConfirmModalOpen(true);
  };

  const handleSubmitConfirmationModal = async () => {
    if (confirmModalInfo.action === "disconnect") {
      try {
        await api.delete(`/whatsappsession/${confirmModalInfo.whatsAppId}`);
      } catch (err) {
        toastError(err);
      }
    }

    if (confirmModalInfo.action === "delete") {
      try {
        await api.delete(`/whatsapp/${confirmModalInfo.whatsAppId}`);
        toast.success(i18n.t("connections.toasts.deleted"));
      } catch (err) {
        toastError(err);
      }
    }
    if (confirmModalInfo.action === "closedImported") {
      try {
        await api.post(`/closedimported/${confirmModalInfo.whatsAppId}`);
        toast.success(i18n.t("connections.toasts.closedimported"));
      } catch (err) {
        toastError(err);
      }
    }


    setConfirmModalInfo(confirmationModalInitialState);
  };


  const renderImportButton = (whatsApp) => {
    if (whatsApp?.statusImportMessages === "renderButtonCloseTickets") {
      return (
        <Button
          style={{ marginLeft: 12 }}
          size="small"
          variant="outlined"
          color="primary"
          onClick={() => {
            handleOpenConfirmationModal("closedImported", whatsApp.id);
          }}
        >
          {i18n.t("connections.buttons.closedImported")}
        </Button>
      );
    }

    if (whatsApp?.importOldMessages) {
      let isTimeStamp = !isNaN(
        new Date(Math.floor(whatsApp?.statusImportMessages)).getTime()
      );

      if (isTimeStamp) {
        const ultimoStatus = new Date(
          Math.floor(whatsApp?.statusImportMessages)
        ).getTime();
        const dataLimite = +add(ultimoStatus, { seconds: +35 }).getTime();
        if (dataLimite > new Date().getTime()) {
          return (
            <>
              <Button
                disabled
                style={{ marginLeft: 12 }}
                size="small"
                endIcon={
                  <CircularProgress
                    size={12}
                    className={classes.buttonProgress}
                  />
                }
                variant="outlined"
                color="primary"
              >
                {i18n.t("connections.buttons.preparing")}
              </Button>
            </>
          );
        }
      }
    }
  };

  const renderActionButtons = (whatsApp) => {
    // Log SEMPRE para debug
    console.log("[DEBUG] renderActionButtons CHAMADO - ID:", whatsApp?.id, "Channel:", whatsApp?.channel, "Status:", whatsApp?.status, "Full object:", whatsApp);
    
    // Debug: verificar channel e status
    const isWebchat = whatsApp?.channel === "webchat" || whatsApp?.channel?.toLowerCase() === "webchat";
    const isConnected = whatsApp?.status === "CONNECTED" || whatsApp?.status?.toUpperCase() === "CONNECTED";
    
    if (isWebchat) {
      console.log("[DEBUG] ✅ WebChat detectado! Status:", whatsApp?.status, "isConnected:", isConnected);
    }
    
    return (
      <>
        {hasAvailableQrCode(whatsApp) && (
          <Can
            role={user.profile === "user" ? "admin" : user.profile}
            perform="connections-page:addConnection"
            yes={() => (
              <>
                <Button
                  size="small"
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    console.log("[FRONTEND-DEBUG] Botão QR CODE clicado - WhatsApp ID:", whatsApp.id);
                    handleOpenQrModal(whatsApp);
                  }}
                >
                  {i18n.t("connections.buttons.qrcode")}
                </Button>
                {whatsApp.channel === "wuzapi" && (
                  <Button
                    size="small"
                    variant="outlined"
                    color="primary"
                    onClick={() => {
                      console.log("[FRONTEND-DEBUG] Botão PairPhone clicado - WhatsApp ID:", whatsApp.id);
                      handleOpenPairPhoneModal(whatsApp);
                    }}
                    style={{ marginLeft: 8 }}
                  >
                    Conectar via Telefone
                  </Button>
                )}
              </>
            )}
          />
        )}
        {(whatsApp.channel === "whatsapp" || whatsApp.channel === "whatsmeow" || whatsApp.channel === "wuzapi") && (whatsApp.status === "DISCONNECTED" || whatsApp.status === "TIMEOUT") && (
          <Can
            role={user.profile === "user" ? "admin" : user.profile}
            perform="connections-page:addConnection"
            yes={() => (
              <>
                <Button
                  size="small"
                  variant="outlined"
                  color="primary"
                  onClick={() => {
                    console.log("[FRONTEND-DEBUG] Botão 'Tentar Novamente' clicado - WhatsApp ID:", whatsApp.id, "Channel:", whatsApp.channel);
                    handleStartWhatsAppSession(whatsApp.id);
                  }}
                >
                  {i18n.t("connections.buttons.tryAgain")}
                </Button>{" "}
                <Button
                  size="small"
                  variant="outlined"
                  color="secondary"
                  onClick={() => {
                    console.log("[FRONTEND-DEBUG] Botão 'Novo QR CODE' clicado - WhatsApp ID:", whatsApp.id, "Channel:", whatsApp.channel);
                    handleRequestNewQrCode(whatsApp.id);
                  }}
                >
                  {i18n.t("connections.buttons.newQr")}
                </Button>
              </>
            )}
          />
        )}
        {((whatsApp.channel === "whatsapp" || whatsApp.channel === "whatsmeow" || whatsApp.channel === "wuzapi") && (whatsApp.status === "CONNECTED" ||
          whatsApp.status === "PAIRING" ||
          whatsApp.status === "TIMEOUT")) && (
            <Can
              role={user.profile}
              perform="connections-page:addConnection"
              yes={() => (
                <>
                  <Button
                    size="small"
                    variant="outlined"
                    color="secondary"
                    onClick={() => {
                      handleOpenConfirmationModal("disconnect", whatsApp.id);
                    }}
                  >
                    {i18n.t("connections.buttons.disconnect")}
                  </Button>

                  {renderImportButton(whatsApp)}
                </>
              )}
            />
          )}
        {((whatsApp.channel === "whatsapp" || whatsApp.channel === "whatsmeow" || whatsApp.channel === "wuzapi") && whatsApp.status === "OPENING" && !hasAvailableQrCode(whatsApp)) && (
          <Button size="small" variant="outlined" disabled color="default">
            {i18n.t("connections.buttons.connecting")}
          </Button>
        )}
        {(whatsApp.channel === "webchat" && (whatsApp.status === "CONNECTED" ||
          whatsApp.status === "PAIRING" ||
          whatsApp.status === "TIMEOUT")) && (
            <Can
              role={user.profile}
              perform="connections-page:addConnection"
              yes={() => (
                <Button
                  size="small"
                  variant="contained"
                  color="primary"
                  startIcon={<Code />}
                  onClick={() => {
                    handleEditWhatsApp(whatsApp);
                  }}
                >
                  Ver Código
                </Button>
              )}
            />
          )}
      </>
    );
  };

  const renderStatusToolTips = (whatsApp) => {
    return (
      <div className={classes.customTableCell}>
        {whatsApp.status === "DISCONNECTED" && (
          <CustomToolTip
            title={i18n.t("connections.toolTips.disconnected.title")}
            content={i18n.t("connections.toolTips.disconnected.content")}
          >
            <SignalCellularConnectedNoInternet0Bar color="secondary" />
          </CustomToolTip>
        )}
        {hasAvailableQrCode(whatsApp) && (
          <CustomToolTip
            title={i18n.t("connections.toolTips.qrcode.title")}
            content={i18n.t("connections.toolTips.qrcode.content")}
          >
            <CropFree />
          </CustomToolTip>
        )}
        {whatsApp.status === "OPENING" && !hasAvailableQrCode(whatsApp) && (
          <CircularProgress size={24} className={classes.buttonProgress} />
        )}
        {whatsApp.status === "CONNECTED" && (
          <CustomToolTip title={i18n.t("connections.toolTips.connected.title")}>
            <SignalCellular4Bar style={{ color: green[500] }} />
          </CustomToolTip>
        )}
        {(whatsApp.status === "TIMEOUT" || whatsApp.status === "PAIRING") && (
          <CustomToolTip
            title={i18n.t("connections.toolTips.timeout.title")}
            content={i18n.t("connections.toolTips.timeout.content")}
          >
            <SignalCellularConnectedNoInternet2Bar color="secondary" />
          </CustomToolTip>
        )}
      </div>
    );
  };

  const restartWhatsapps = async () => {

    try {
      await api.post(`/whatsapp-restart/`);
      toast.success(i18n.t("connections.waitConnection"));
    } catch (err) {
      toastError(err);
    }
  }

  const handleOpenTransferModal = () => {
    setTransferModalOpen(true);
  };

  const handleCloseTransferModal = () => {
    setTransferModalOpen(false);
    setSourceConnection("");
    setTargetConnection("");
    setIncludeTicketsWithoutConnection(false);
  };

  const handleCloseTransferProgressModal = () => {
    setTransferProgressModalOpen(false);
    setTransferProgress({ current: 0, total: 0, percentage: 0, failed: 0, jobId: null });
  };

  const handleCancelTransfer = async () => {
    if (!transferProgress.jobId) {
      toast.error("Não é possível cancelar esta transferência.");
      return;
    }

    try {
      await api.post(`/transfer-tickets/${transferProgress.jobId}/cancel`);
      toast.info("Cancelamento solicitado. Aguarde...");
    } catch (err) {
      toastError(err);
    }
  };

  const handleTransferTickets = async () => {
    if (!targetConnection) {
      toast.error("Selecione a conexão de destino");
      return;
    }

    // Se não estiver marcado para incluir tickets sem conexão, precisa selecionar origem
    if (!includeTicketsWithoutConnection) {
      if (!sourceConnection) {
        toast.error("Selecione a conexão de origem");
        return;
      }

      if (sourceConnection === targetConnection) {
        toast.error("As conexões de origem e destino devem ser diferentes");
        return;
      }
    }

    try {
      const response = await api.post(`/transfer-tickets`, {
        sourceConnectionId: includeTicketsWithoutConnection ? null : sourceConnection,
        targetConnectionId: targetConnection,
        includeTicketsWithoutConnection: includeTicketsWithoutConnection
      });

      if (response.data.requiresProgress) {
        setTransferModalOpen(false);
        setTransferProgressModalOpen(true);
        setTransferProgress({ 
          current: 0, 
          total: response.data.totalTickets, 
          percentage: 0,
          failed: 0,
          jobId: response.data.jobId 
        });
      } else {
        const successMsg = response.data.failed > 0
          ? `Transferência concluída! ${response.data.transferred || 0} tickets transferidos. ${response.data.failed} tickets falharam.`
          : `Tickets transferidos com sucesso! ${response.data.transferred || 0} tickets transferidos.`;
        toast.success(successMsg);
        handleCloseTransferModal();
      }
    } catch (err) {
      toastError(err);
    }
  };

  const handleOpenPreDeleteModal = (whatsAppId) => {
    setWhatsAppToDelete(whatsAppId);
    setPreDeleteModalOpen(true);
  };

  const handleClosePreDeleteModal = () => {
    setPreDeleteModalOpen(false);
    setWhatsAppToDelete(null);
  };

  const handleConfirmTransferDone = () => {
    setPreDeleteModalOpen(false);
    handleOpenConfirmationModal("delete", whatsAppToDelete);
    setWhatsAppToDelete(null);
  };

  return (
    <MainContainer>
      <ConfirmationModal
        title={confirmModalInfo.title}
        open={confirmModalOpen}
        onClose={setConfirmModalOpen}
        onConfirm={handleSubmitConfirmationModal}
      >
        {confirmModalInfo.message}
      </ConfirmationModal>
      {qrModalOpen && (
        <QrcodeModal
          open={qrModalOpen}
          onClose={handleCloseQrModal}
          whatsAppId={!whatsAppModalOpen && selectedWhatsApp?.id}
          onOpenPairPhone={() => {
            handleCloseQrModal();
            handleOpenPairPhoneModal(selectedWhatsApp);
          }}
          channel={selectedWhatsApp?.channel}
        />
      )}
      {pairPhoneModalOpen && (
        <PairPhoneModal
          open={pairPhoneModalOpen}
          onClose={handleClosePairPhoneModal}
          whatsAppId={selectedWhatsApp?.id}
        />
      )}
      <WhatsAppModal
        open={whatsAppModalOpen}
        onClose={handleCloseWhatsAppModal}
        whatsAppId={!qrModalOpen && selectedWhatsApp?.id}
        channel={channel}
      />
      <Dialog
        open={transferModalOpen}
        onClose={handleCloseTransferModal}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Transferência de Tickets</DialogTitle>
        <DialogContent>
          <Typography variant="body1" style={{ marginBottom: 24, lineHeight: 1.6 }}>
            Para transferir os tickets, selecione a conexão de <strong>origem</strong> (de onde os tickets serão movidos) 
            e a conexão de <strong>destino</strong> (para onde os tickets serão transferidos). 
            Todos os atendimentos da conexão de origem serão movidos para a conexão de destino.
            {includeTicketsWithoutConnection && (
              <span style={{ display: 'block', marginTop: 8, color: '#1976d2', fontWeight: 'bold' }}>
                Modo: Transferindo tickets sem conexão ativa
              </span>
            )}
          </Typography>
          
          <div style={{ display: 'flex', alignItems: 'center', gap: 24, marginBottom: 24 }}>
            <FormControl fullWidth>
              <InputLabel>Origem</InputLabel>
              <Select
                value={sourceConnection}
                onChange={(e) => setSourceConnection(e.target.value)}
                label="Origem"
                disabled={includeTicketsWithoutConnection}
              >
                {whatsApps.map((whatsApp) => (
                  <MuiMenuItem key={whatsApp.id} value={whatsApp.id}>
                    {whatsApp.name}
                  </MuiMenuItem>
                ))}
              </Select>
            </FormControl>

            <div style={{ fontSize: 24, color: '#4caf50', fontWeight: 'bold' }}>
              →
            </div>

            <FormControl fullWidth>
              <InputLabel>Destino</InputLabel>
              <Select
                value={targetConnection}
                onChange={(e) => setTargetConnection(e.target.value)}
                label="Destino"
              >
                {whatsApps.map((whatsApp) => (
                  <MuiMenuItem key={whatsApp.id} value={whatsApp.id}>
                    {whatsApp.name}
                  </MuiMenuItem>
                ))}
              </Select>
            </FormControl>
          </div>

          <div style={{ marginTop: 16, marginBottom: 8, display: 'flex', alignItems: 'center', gap: 8 }}>
            <MuiTooltip 
              title="Marcando esse CheckBox, o sistema vai buscar os tickets sem fila, recurso ideal, para caso tenha apagado a conexão, sem antes transferir os tickets."
              arrow
              placement="top"
            >
              <HelpOutline style={{ color: '#1976d2', cursor: 'help', fontSize: 20 }} />
            </MuiTooltip>
            <FormControlLabel
              control={
                <Checkbox
                  checked={includeTicketsWithoutConnection}
                  onChange={(e) => setIncludeTicketsWithoutConnection(e.target.checked)}
                  color="primary"
                />
              }
              label="TRANSFERIR TICKETS SEM CONEXÃO TAMBÉM"
            />
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseTransferModal} color="default">
            CANCELAR
          </Button>
          <Button onClick={handleTransferTickets} color="primary" variant="contained">
            TRANSFERIR
                     </Button>
         </DialogActions>
       </Dialog>
       <Dialog
         open={transferProgressModalOpen}
         onClose={handleCloseTransferProgressModal}
         maxWidth="sm"
         fullWidth
         disableBackdropClick
         disableEscapeKeyDown
       >
         <DialogTitle>Transferindo Tickets</DialogTitle>
         <DialogContent>
           <div style={{ textAlign: 'center', padding: '20px 0' }}>
             <Typography variant="h6" style={{ marginBottom: 16 }}>
               Progresso da Transferência
             </Typography>
             
             <Box position="relative" display="inline-flex" marginBottom={2}>
               <CircularProgress 
                 variant="determinate" 
                 value={transferProgress.percentage} 
                 size={80}
                 thickness={4}
               />
               <Box
                 top={0}
                 left={0}
                 bottom={0}
                 right={0}
                 position="absolute"
                 display="flex"
                 alignItems="center"
                 justifyContent="center"
               >
                 <Typography variant="caption" component="div" color="textSecondary" style={{ fontSize: '14px', fontWeight: 'bold' }}>
                   {transferProgress.percentage}%
                 </Typography>
               </Box>
             </Box>

             <Typography variant="body1" style={{ marginTop: 16 }}>
               {transferProgress.current} de {transferProgress.total} tickets transferidos
             </Typography>
             
             {transferProgress.failed > 0 && (
               <Typography variant="body2" color="error" style={{ marginTop: 8 }}>
                 {transferProgress.failed} tickets falharam na transferência
               </Typography>
             )}
             
             <Typography variant="body2" color="textSecondary" style={{ marginTop: 8 }}>
               Por favor, aguarde enquanto os tickets são transferidos...
             </Typography>
           </div>
         </DialogContent>
         <DialogActions>
           <Button 
             onClick={handleCancelTransfer} 
             color="secondary" 
             variant="outlined"
             disabled={!transferProgress.jobId || transferProgress.percentage === 100}
           >
             CANCELAR TRANSFERÊNCIA
           </Button>
         </DialogActions>
       </Dialog>
       <Dialog
         open={preDeleteModalOpen}
         onClose={handleClosePreDeleteModal}
         maxWidth="sm"
         fullWidth
       >
         <DialogTitle>Transferência de Tickets</DialogTitle>
         <DialogContent>
           <Typography variant="body1" style={{ marginBottom: 16 }}>
             Antes de excluir esta conexão, você já fez a transferência dos tickets para outra conexão?
           </Typography>
         </DialogContent>
         <DialogActions>
           <Button onClick={handleClosePreDeleteModal} color="default">
             NÃO
           </Button>
           <Button onClick={handleConfirmTransferDone} color="primary" variant="contained">
             SIM
           </Button>
         </DialogActions>
       </Dialog>
      <>
          <MainHeader>
            <Title>{i18n.t("connections.title")} ({whatsApps.length})</Title>
            <MainHeaderButtonsWrapper>
              {user.profile === "admin" && (
                <>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleOpenTransferModal}
                  >
                    Transferir Tickets
                  </Button>

                  <Button
                    variant="contained"
                    color="primary"
                    onClick={restartWhatsapps}
                  >
                    {i18n.t("connections.restartConnections")}
                  </Button>
                </>
              )}

              <Button
                variant="contained"
                color="primary"
                onClick={() => openInNewTab(`https://wa.me/${process.env.REACT_APP_NUMBER_SUPPORT}`)}
              >
                {i18n.t("connections.callSupport")}
              </Button>
              <PopupState variant="popover" popupId="demo-popup-menu">
                {(popupState) => (
                  <React.Fragment>
                    <Can
                      role={user.profile}
                      perform="connections-page:addConnection"
                      yes={() => (
                        <>
                          <Button
                            variant="contained"
                            color="primary"
                            {...bindTrigger(popupState)}
                          >
                            {i18n.t("connections.newConnection")}
                          </Button>
                          <Menu {...bindMenu(popupState)}>
                            {/* WHATSAPP */}
                            <MenuItem
                              disabled={planConfig?.plan?.useWhatsapp ? false : true}
                              onClick={() => {
                                handleOpenWhatsAppModal("whatsapp");
                                popupState.close();
                              }}
                            >
                              <WhatsApp
                                fontSize="small"
                                style={{
                                  marginRight: "10px",
                                  color: "#25D366",
                                }}
                              />
                              WhatsApp
                            </MenuItem>
                            {/* WHATSAPP OFICIAL */}
                            <MenuItem
                              disabled={planConfig?.plan?.useWhatsappOfficial ? false : true}
                              onClick={() => {
                                handleOpenWhatsAppModal("whatsapp_oficial");
                                popupState.close();
                              }}
                            >
                              <WhatsApp
                                fontSize="small"
                                style={{
                                  marginRight: "10px",
                                  color: "#25D366",
                                }}
                              />
                              WhatsApp Oficial
                            </MenuItem>
                            {/* FACEBOOK */}
                            <FacebookLogin
                              appId={process.env.REACT_APP_FACEBOOK_APP_ID}
                              autoLoad={false}
                              fields="name,email,picture"
                              version="9.0"
                              scope={process.env.REACT_APP_REQUIRE_BUSINESS_MANAGEMENT?.toUpperCase() === "TRUE" ?
                                "public_profile,pages_messaging,pages_show_list,pages_manage_metadata,pages_read_engagement,business_management"
                                : "public_profile,pages_messaging,pages_show_list,pages_manage_metadata,pages_read_engagement"}
                              callback={responseFacebook}
                              render={(renderProps) => (
                                <MenuItem
                                  disabled={planConfig?.plan?.useFacebook ? false : true}
                                  onClick={renderProps.onClick}
                                >
                                  <Facebook
                                    fontSize="small"
                                    style={{
                                      marginRight: "10px",
                                      color: "#3b5998",
                                    }}
                                  />
                                  Facebook
                                </MenuItem>
                              )}
                            />
                            {/* INSTAGRAM */}
                            <FacebookLogin
                              appId={process.env.REACT_APP_FACEBOOK_APP_ID}
                              autoLoad={false}
                              fields="name,email,picture"
                              version="9.0"
                              scope={process.env.REACT_APP_REQUIRE_BUSINESS_MANAGEMENT?.toUpperCase() === "TRUE" ?
                                "public_profile,instagram_basic,instagram_manage_messages,pages_messaging,pages_show_list,pages_manage_metadata,pages_read_engagement,business_management"
                                : "public_profile,instagram_basic,instagram_manage_messages,pages_messaging,pages_show_list,pages_manage_metadata,pages_read_engagement"}
                              callback={responseInstagram}
                              render={(renderProps) => (
                                <MenuItem
                                  disabled={planConfig?.plan?.useInstagram ? false : true}
                                  onClick={renderProps.onClick}
                                >
                                  <Instagram
                                    fontSize="small"
                                    style={{
                                      marginRight: "10px",
                                      color: "#e1306c",
                                    }}
                                  />
                                  Instagram
                                </MenuItem>
                              )}
                            />
                            {/* WEBCHAT */}
                            <MenuItem
                              onClick={() => {
                                handleOpenWhatsAppModal("webchat");
                                popupState.close();
                              }}
                            >
                              <Chat
                                fontSize="small"
                                style={{
                                  marginRight: "10px",
                                  color: "#0066ff",
                                }}
                              />
                              WebChat
                            </MenuItem>
                          </Menu>
                        </>
                      )}
                    />
                  </React.Fragment>
                )}
              </PopupState>
            </MainHeaderButtonsWrapper>
          </MainHeader>

          {
            statusImport?.all ? (
              <>
                <div style={{ margin: "auto", marginBottom: 12 }}>
                  <Card className={classes.root}>
                    <CardContent className={classes.content}>
                      <Typography component="h5" variant="h5">

                        {statusImport?.this === -1 ? i18n.t("connections.buttons.preparing") : i18n.t("connections.buttons.importing")}

                      </Typography>
                      {statusImport?.this === -1 ?
                        <Typography component="h6" variant="h6" align="center">

                          <CircularProgress
                            size={24}
                          />

                        </Typography>
                        :
                        <>
                          <Typography component="h6" variant="h6" align="center">
                            {`${i18n.t(`connections.typography.processed`)} ${statusImport?.this} ${i18n.t(`connections.typography.in`)} ${statusImport?.all}  ${i18n.t(`connections.typography.date`)}: ${statusImport?.date} `}
                          </Typography>
                          <Typography align="center">
                            <CircularProgressWithLabel
                              style={{ margin: "auto" }}
                              value={(statusImport?.this / statusImport?.all) * 100}
                            />
                          </Typography>
                        </>
                      }
                    </CardContent>
                  </Card>
                </div>
              </>
            ) : null
          }

          <Paper className={classes.mainPaper} variant="outlined">
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell align="center">Channel</TableCell>
                  <TableCell align="center">{i18n.t("connections.table.color")}</TableCell>
                  <TableCell align="center">{i18n.t("connections.table.name")}</TableCell>
                  <TableCell align="center">{i18n.t("connections.table.number")}</TableCell>
                  <TableCell align="center">{i18n.t("connections.table.status")}</TableCell>
                  <TableCell align="center">{i18n.t("connections.table.session")}</TableCell>
                  <TableCell align="center">{i18n.t("connections.table.lastUpdate")}</TableCell>
                  <TableCell align="center">{i18n.t("connections.table.default")}</TableCell>
                  <TableCell align="center">{i18n.t("connections.table.receiveComments")}</TableCell>
                  <Can
                    role={user.profile}
                    perform="connections-page:addConnection"
                    yes={() => (
                      <TableCell align="center">{i18n.t("connections.table.actions")}</TableCell>
                    )}
                  />
                </TableRow>
              </TableHead>
              <TableBody>
                {loading ? (
                  <TableRowSkeleton />
                ) : (
                  <>
                    {whatsApps?.length > 0 &&
                      whatsApps.map((whatsApp) => {
                        // Log para debug
                        if (whatsApp.channel === "webchat" || whatsApp.channel?.toLowerCase() === "webchat") {
                          console.log("[DEBUG] 🟢 WebChat encontrado no MAP! ID:", whatsApp.id, "Channel:", whatsApp.channel, "Status:", whatsApp.status);
                        }
                        // Log para debug WuzAPI
                        if (whatsApp.channel === "wuzapi" || whatsApp.channel?.toLowerCase() === "wuzapi") {
                          console.log("[DEBUG] 🟡 WuzAPI encontrado no MAP! ID:", whatsApp.id, "Channel:", whatsApp.channel, "Status:", whatsApp.status);
                        }
                        return (
                        <TableRow key={whatsApp.id}>
                          <TableCell align="center">{IconChannel(whatsApp.channel)}</TableCell>
                          <TableCell align="center">
                            <div className={classes.customTableCell}>
                              <span
                                style={{
                                  backgroundColor: whatsApp.color,
                                  width: 60,
                                  height: 20,
                                  alignSelf: "center",
                                }}
                              />
                            </div>
                          </TableCell>
                          <TableCell align="center">{whatsApp.name}</TableCell>
                          <TableCell align="center">
                            {whatsApp.channel === 'whatsapp' && whatsApp.number
                              ? <>{formatSerializedId(whatsApp.number)}</>
                              : whatsApp.channel === 'whatsapp_oficial' && whatsApp.phone_number
                                  ? <>{formatSerializedId(whatsApp.phone_number)}</>
                                  : "-"}
                          </TableCell>
                          <TableCell align="center">{renderStatusToolTips(whatsApp)}</TableCell>
                          <TableCell align="center">{renderActionButtons(whatsApp)}</TableCell>
                          <TableCell align="center">{format(parseISO(whatsApp.updatedAt), "dd/MM/yy HH:mm")}</TableCell>
                          <TableCell align="center">
                            {whatsApp.isDefault && (
                              <div className={classes.customTableCell}>
                                <CheckCircle style={{ color: green[500] }} />
                              </div>
                            )}
                          </TableCell>
                          <TableCell align="center">
                            {(whatsApp.channel === "facebook" || whatsApp.channel === "instagram") && (
                              <Tooltip 
                                title={
                                  whatsApp.receiveComments 
                                    ? i18n.t("connections.receiveComments.tooltip.enabled")
                                    : i18n.t("connections.receiveComments.tooltip.disabled")
                                }
                              >
                                <Switch
                                  checked={whatsApp.receiveComments !== false}
                                  onChange={() => handleToggleReceiveComments(whatsApp)}
                                  color="primary"
                                  size="small"
                                />
                              </Tooltip>
                            )}
                          </TableCell>
                          <Can
                            role={user.profile}
                            perform="connections-page:addConnection"
                            yes={() => (
                              <TableCell align="center">
                                <IconButton
                                  size="small"
                                  onClick={() => handleEditWhatsApp(whatsApp)}
                                >
                                  <Edit />
                                </IconButton>

                                <IconButton
                                  size="small"
                                  onClick={(e) => {
                                    handleOpenPreDeleteModal(whatsApp.id);
                                  }}
                                >
                                  <DeleteOutline />
                                </IconButton>
                                {whatsApp.channel === "whatsapp_oficial" && (
                                  <>
                                    <Tooltip title="Sincronizar templates">
                                      <IconButton
                                        size="small"
                                        aria-label="sync-templates"
                                        onClick={(e) => {
                                          handleSyncTemplates(whatsApp.id);
                                        }}
                                      >
                                        <Sync />
                                      </IconButton>
                                    </Tooltip>
                                    <Tooltip title="Copiar URL de Webhook para a Meta">
                                      <IconButton
                                        size="small"
                                        aria-label="copy-webhook"
                                        onClick={(e) => {
                                          handleCopyWebhook(whatsApp);
                                        }}
                                      >
                                        <WebhookIcon />
                                      </IconButton>
                                    </Tooltip>
                                  </>
                                )}
                              </TableCell>
                            )}
                          />
                        </TableRow>
                        );
                      })}
                  </>
                )}
              </TableBody>
            </Table>
          </Paper>
      </>
    </MainContainer >

  );
};

export default Connections;
